import { render } from "./AppFundamental.vue?vue&type=template&id=c6b8fc94&scoped=true"
import script from "./AppFundamental.vue?vue&type=script&lang=js"
export * from "./AppFundamental.vue?vue&type=script&lang=js"

import "./AppFundamental.vue?vue&type=style&index=0&id=c6b8fc94&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b8fc94"]])

export default __exports__